import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Animated } from "react-animated-css";
import MaskedInput from "react-text-mask";
import { Input } from "reactstrap";
import { isEmpty } from "lodash";

import api from "../services/Api";
import instance from "../services/axios";
import { auth } from "../services/Firebase";

import { handleLogout } from "../assets/js/Logout";

import Perfil from "../components/Perfil";
import Dispositivos from "../components/Dispositivos";
import RedefineProfile from "../components/RedefineProfile";
import RedefineEmail from "../components/Redefines/RedefineEmail";
import RedefinePass from "../components/Redefines/RedefinePass";
import ModalConfirm from "../components/hoc/ModalConfirm";
import ModalAttention from "../components/hoc/ModalAttention";
import Loading from "../components/Loading";

import { checkCPF } from "../libs/Validate";

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ModalTitle: <p style={{ color: "black" }}>Atenção</p>,
      allUser: "",
      isAuthing: true, // carregar pagina
      tokenVerify: false, // esta vindo da autenticação
      data: null,
      showForm: "dispositivos",
      changedShowForm: true,
      isLoading: true,
      modalCpf: false,
      modal: false,
      userUid: null,
      userId: null,
      ModalToken: false,
      ModalCpfAlready: false,
      cpfOk: "",
      cpfAux: "",
      contatoOk: "",
      nome_maeOk: "",
      cpfValue: "",
      telefoneValue: "",
      datanasciValue: "",
      sendApi: false,
      cpfRegex: [
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        ".",
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        ".",
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        "-",
        /[0-9]/,
        /[0-9]/,
      ],
      contatoRegex: [
        "(",
        /\d/,
        /\d/,
        ")",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ],
      nascRegex: [/[0-3]/, /\d/, "/", /[0-1]/, /\d/, "/", /[1-2]/, /\d/, /\d/, /\d/],
      nascOk: "",
    };
    this.handleInsertCpf = this.handleInsertCpf.bind(this);
    this.handleShowForm = this.handleShowForm.bind(this);
    this.handleRefresh = this.handleRefresh.bind(this);
  }

  componentWillMount() {
    auth.onAuthStateChanged(async (data) => {
      var token;
      if (data) {
        token = data._lat;
        instance.defaults.headers.Authorization = token;
      } else {
        this.setState({ tokenVerify: true });
      }
    });
    this.verifyAll();
  }

  componentWillUnmount() {
    this.setState({
      modalCpf: undefined,
      allUser: undefined,
      isLoading: undefined,
      isAuthing: undefined,
      tokenVerify: undefined,
      data: undefined,
      userUid: undefined,
      showForm: undefined,
      changedShowForm: undefined,
      ModalToken: undefined,
      cpfOk: undefined,
      contatoOk: undefined,
      cpfRegex: undefined,
      contatoRegex: undefined,
    });
  }

  handleRefresh() {
    this.componentWillMount();
  }

  verifyAll = () => {
    auth.onAuthStateChanged(async (data) => {
      // console.log("data>", data)
      if (data !== null && data.uid !== null) {
        await api
          .loadUserByUid(data.uid)
          .then((user) => {
            // console.log("user", user)
            if (!isEmpty(user.data[0])) {
              this.setState({
                allUser: user.data[0],
                isLoading: false,
                isAuthing: false,
                // tokenVerify: !!data,
                tokenVerify: false,
                data: data.providerData,
                userUid: data.uid,
                userId: user.data[0].id,
              });
              if (isEmpty(user.data[0].cpf)) {
                this.setState({ modalCpf: !this.state.modalCpf });
              }
            }
            else{
              const cpf = undefined;
              const nomeCompleto = data.displayName;
              const genero = null;
              const email = data.email;
              const foto = data.photoURL;
              const local = null;
              const uid = data.uid;

              const NewUser = {
                nome: nomeCompleto,
                genero: genero,
                email: email,
                foto: foto,
                local: local,
                uid: uid,
                cpf: cpf,
                telefone: undefined,
              };

              api.saveUser(NewUser)
              .then(() => {
                // console.log("response salv banco", Response)
                document.location.reload();
              })
              .catch((err) => {
                console.log("erro ao salvar usuario", err)
              
              });
            }
          })
          .catch((err) => {
            console.log("Load user ERROR:", err);
            var error = err.response || 1;
            if (error.status === 401) {
              this.onModalToken();
              document.location.reload();
            }
          });
      }
    });
  };

  handleLogoutFire = async () => {
    await handleLogout();
    await this.setState({ tokenVerify: true });
  };

  handleAlterPerfil = (value) => {
    if (value !== undefined) this.setState({ allUser: value });
  };

  handleShowForm(value) {
    // this.setState({ showForm: null, changedShowForm: false });
    // setTimeout(() => {
    this.setState({ showForm: value, changedShowForm: true });
    // }, 200);

    return null;
  }

  handleInsertCpf() {
    this.setState({ sendApi: true });
    const usercpf = {
      id: this.state.allUser.id,
      nome: this.state.allUser.nome,
      genero: this.state.allUser.genero,
      validateEmail: this.state.allUser.validateEmail,
      email: this.state.allUser.email,
      foto: this.state.allUser.foto,
      local: this.state.allUser.local,
      uid: this.state.allUser.uid,
      cpf: this.state.cpfValue,
      telefone: this.state.telefoneValue,
      nome_mae: this.nome_mae.value,
      datanasc: this.state.datanasciValue,
    };
    if (this.campoValido() === true && checkCPF(this.state.cpfValue) === true) {
      api
        .updateUser(usercpf)
        .then(async (resp) => {
          await this.verifyAll();
          await this.setState({ modalCpf: !this.state.modalCpf, sendApi: false });
        })
        .catch((err) => {
          console.log("update user erro:", err)
          // if (err.response.status == 422)
          this.setState({ sendApi: false });
          if (err.response.status === 401) {
            this.onModalToken();
          } else {
            this.setState({ ModalCpfAlready: !this.state.ModalCpfAlready });
          }
        });
    } else if (this.campoValido() === true && checkCPF(this.state.cpfValue) === false) {
      alert("CPF digitado inválido!!");
      this.setState({ sendApi: false });
    } else {
      alert("Campos não preenchidos corretamente");
      this.setState({ sendApi: false });
    }
  } //InsertCPF

  campoValido = () => {
    if (
      this.state.cpfOk === true &&
      this.state.contatoOk === true &&
      this.state.nome_maeOk === true &&
      this.state.nascOk === true
    ) {
      return true;
    } else {
      return false;
    }
  };

  onModalToken = (event) => {
    // console.log("TRIGGERED MODAL TOKEN");
    this.setState({ ModalToken: !this.state.ModalToken });
  };

  onModal = (event) => {
    this.setState({ modal: !this.state.modal });
  };

  valid = (evento) => {
    const campo = evento.target.id;
    const value = evento.target.value;

    switch (campo) {
      case "cpf":
        this.setState({ cpfAux: evento.target.value });
        if (value.match(/^[0-9]{3}.[0-9]{3}.[0-9]{3}-[0-9]{2}/) !== null) {
          this.setState({ cpfOk: true });
        } else {
          this.setState({ cpfOk: false });
        }
        break;

      case "inputContato1":
        if (value.match(/^\(\d{2}\)\d{4,5}-\d{3,4}/) !== null) {
          this.setState({ contatoOk: true });
        } else {
          this.setState({ contatoOk: false });
        }
        break;

      case "nome_mae":
        if (
          value.match(
            /^[A-ZÀ-Úa-zà-ú]{3,}\s[A-ZÀ-Úa-zà-ú]{2,}\s?([A-ZÀ-Úa-zà-ú]{2,})?\s?([A-ZÀ-Úa-zà-ú]{2,})?\s?([A-ZÀ-Úa-zà-ú]{2,})\s?([A-ZÀ-Úa-zà-ú]{2,})?$/
          )
        ) {
          this.setState({ nome_maeOk: true });
        } else {
          this.setState({ nome_maeOk: false });
        }

        break;
      case "datanasci":
        if (value.match(/[0-3]/, /\d/, "/", /[0-1]/, /\d/, "/", /[1-2]/, /\d/, /\d/, /\d/)) {
          this.setState({ nascOk: true });
        } else {
          this.setState({ nascOk: false });
        }

        break;

      default:
        break;
    }
  };

  handleCpf() {
    return (
      <div>
        <Modal
          isOpen={this.state.modalCpf}
          className={this.props.className}
          style={{ color: "black" }}
        >
          <ModalHeader style={{ color: "black" }}>Insira o CPF!</ModalHeader>
          <ModalBody style={{ color: "black" }}>
            {this.state.ModalCpfAlready ? (
              <div>
                <br />
                <p style={{ color: "red" }}>CPF JÁ EXISTE, FAVOR INSERIR OUTRO</p>
              </div>
            ) : null}
            Informe seu dados para ter acesso à aplicação.
            <br />
            <a>Cpf*</a>
            <br />
            <MaskedInput
              id="cpf"
              mask={this.state.cpfRegex}
              type="text"
              showMask="true"
              invalid={!this.state.cpfOk}
              onChange={(e) => {
                this.valid(e);
                this.setState({ cpfValue: e.target.value });
              }}
              render={(ref, props) => {
                return <Input innerRef={(input) => (this.cpf = ref(input))} {...props} />;
              }}
            />
            <a>Telefone para Contato*</a>
            <br />
            <MaskedInput
              id="inputContato1"
              mask={this.state.contatoRegex}
              showMask="true"
              invalid={!this.state.contatoOk}
              onChange={(e) => {
                this.valid(e);
                this.setState({ telefoneValue: e.target.value });
              }}
              render={(ref, props) => {
                return <Input innerRef={(input) => (this.telefone = ref(input))} {...props} />;
              }}
            />
            <a>Nome completo da Mãe*</a>
            <br />
            <Input
              id="nome_mae"
              innerRef={(ref) => (this.nome_mae = ref)}
              onChange={this.valid}
              invalid={!this.state.nome_maeOk}
            />
            <a>Data de nascimento*</a>
            <br />
            <MaskedInput
              id="datanasci"
              mask={this.state.nascRegex}
              showMask="true"
              invalid={!this.state.nascOk}
              onChange={(e) => {
                this.valid(e);
                this.setState({ datanasciValue: e.target.value });
              }}
              render={(ref, props) => {
                return <Input innerRef={(input) => (this.datanasci = ref(input))} {...props} />;
              }}
            />
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.handleInsertCpf} disabled={this.state.sendApi}>
              {this.state.sendApi ? "Enviando" : "Enviar"}
            </Button>{" "}
            <Button color="primary" onClick={this.onModal} disabled={this.state.sendApi}>
              Cancelar
            </Button>{" "}
          </ModalFooter>
        </Modal>
        <ModalConfirm
          title={this.state.ModalTitle}
          show={this.state.modal}
          toggle={this.onModal}
          ok={this.handleLogoutFire}
          style={{ color: "black" }}
        >
          <p style={{ color: "black" }}>Tem certeza que deseja sair?</p>
        </ModalConfirm>
      </div>
    );
  }

  render() {
    if (this.state.tokenVerify) return <Redirect to="/" />;

    if (this.state.isLoading)
      return (
        <div className="container Home" style={{ color: "black" }}>
          <Loading />
        </div>
      );

    return (
      <div className="container Home" style={{ color: "black" }}>
        <div>{this.state.modalCpf ? this.handleCpf() : null}</div>

        <Perfil
          allUser={this.state.allUser}
          isLoading={this.state.isLoading}
          data={this.state.data}
          handleLogout={this.handleLogoutFire}
          handleShowForm={(value) => this.handleShowForm(value)}
        />

        <Animated
          animationIn="fadeIn"
          animationOut="fadeOut"
          isVisible={this.props.tablesTransition}
        >
          {this.state.showForm === "perfil" ? (
            <RedefineProfile
              handleShowForm={(value) => this.handleShowForm(value)}
              handleAlterPerfil={this.handleAlterPerfil}
              handleRefresh={this.handleRefresh}
              allUser={this.state.allUser}
              RedefinePasswd={this.RedefinePasswd}
              onModalToken={this.onModalToken}
            />
          ) : null}
          {this.state.showForm === "senha" ? (
            <RedefinePass
              handleShowForm={(value) => this.handleShowForm(value)}
              handleRefresh={this.handleRefresh}
              allUser={this.state.allUser}
              RedefinePasswd={this.RedefinePasswd}
            />
          ) : null}

          {this.state.showForm === "email" ? (
            <RedefineEmail
              onModalToken={this.onModalToken}
              handleShowForm={(value) => this.handleShowForm(value)}
              handleRefresh={this.handleRefresh}
              allUser={this.state.allUser}
              RedefinePasswd={this.RedefinePasswd}
              handleLogoutFire={this.handleLogoutFire}
            />
          ) : null}

          {this.state.showForm === "dispositivos" ? (
            <Dispositivos
              allUser={this.state.allUser}
              userUid={this.state.userUid}
              userId={this.state.userId}
              onModalToken={this.onModalToken}
            />
          ) : null}
        </Animated>

        <ModalAttention
          title={this.state.ModalTitle}
          show={this.state.ModalToken}
          toggle={this.onModalToken}
          ok={this.handleLogoutFire}
          style={{ color: "black" }}
        >
          <p style={{ color: "black" }}>Sua sessão foi expirada, favor entrar novamente!!</p>
        </ModalAttention>
      </div>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/pages/Dashboard.js